import React, { Component } from 'react';

import { connect } from "react-redux";
import { SlPageTitle, SlRadioButton,  SlButton, SlFormEntryRow, SlSectionTitle} from "../editors"
import { registrationActions } from "../../_actions";
import { metadataService } from '../../_services';
import { Row, Col } from 'reactstrap';


class SignUpCustomerStatus extends Component {
    static displayName = SignUpCustomerStatus.name;

    constructor(props) {
        super(props);
        this.state = {
            existingCustomer: 'true'
        };

        this.handleDataChange = this.handleDataChange.bind(this);
    }
    handleDataChange(event) {
        let targetName = event.target.name;
        var stateChanges = {}
        stateChanges[targetName] = event.target.value;
        this.setState(stateChanges)
    }

    submitClick = () => {
        const { dispatch } = this.props;
        let isExistingCustomer = (this.state.existingCustomer === 'true');

        let existingCustomer = { existingCustomer: isExistingCustomer };
        
        dispatch(registrationActions.handleExistingCustomerRequest(existingCustomer));
    }

    render() {
        return (
            <div className="SignUpCustomerStatus">                
                <SlPageTitle pageName="SignUpMainLabel" />
                <Row>
                    <Col>
                        <SlRadioButton fieldName='existingCustomer' onChange={this.handleDataChange} isSelected={this.state.existingCustomer === 'true'} value={"true"}>
                            {metadataService.getLabel('SunLoanCustomer')}
                        </SlRadioButton>
                        <SlRadioButton fieldName='existingCustomer' onChange={this.handleDataChange} isSelected={this.state.existingCustomer !== 'true'} value={"false"}>
                            {metadataService.getLabel('NewCustomer')}
                        </SlRadioButton>
                    </Col>
                </Row>
                <div className="text-center">
                    <SlButton name="Next" size="lg" onClick={this.submitClick}/>
                </div>
            </div>
        );
    }



}

function mapStateToProps(state) {
    const { loggedIn } = state.authentication;

    return {
        loggedIn
    };
}

const connectedSignUpCustomerStatus = connect(mapStateToProps)(SignUpCustomerStatus);
export { connectedSignUpCustomerStatus as SignUpCustomerStatus };